import { IngredientCategory } from "@/lib/types";
import { NutritionCategoryAdapter } from "../types";
import { chocolateNutritionAdapter } from "./chocolate";
import { dairyNutritionAdapter } from "./dairy";
import { fruitNutritionAdapter } from "./fruit";
import { nutNutritionAdapter } from "./nut";
import { otherNutritionAdapter } from "./other";

const registry = {
  chocolate: chocolateNutritionAdapter,
  dairy: dairyNutritionAdapter,
  fruit: fruitNutritionAdapter,
  nut: nutNutritionAdapter,
  other: otherNutritionAdapter,
} satisfies Partial<Record<IngredientCategory, NutritionCategoryAdapter>>;

export function getNutritionAdapter(category: IngredientCategory) {
  switch (category) {
    case "chocolate":
      return registry.chocolate;
    case "dairy":
      return registry.dairy;
    case "fruit":
      return registry.fruit;
    case "nut":
      return registry.nut;
    case "other":
      return registry.other;
    default:
      return null;
  }
}
